import { createReducer } from '@reduxjs/toolkit';
import { SET_ORGANIZATION, SET_SHOP } from 'admin/actions/qr-design-viewer';

type Organization = unknown;
type Shop = unknown;

export type QrDesignViewerState = {
  organization: Organization | null;
  shop: Shop | null;
};

const initState: QrDesignViewerState = {
  organization: null,
  shop: null,
};

export const qrDesignViewerReducer = createReducer(initState, (builder) =>
  builder
    .addCase(SET_ORGANIZATION, (state, action) => {
      return { ...state, organization: action.payload };
    })
    .addCase(SET_SHOP, (state, action) => {
      return { ...state, shop: action.payload };
    })
);

export default qrDesignViewerReducer;
